import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import api from "@/api";
import PageSections from "@/components/PageSections";

const CONTENT = {
  mr: {
    intro: "समता पार्टी आपल्या नावाने आणि 'मशाल' चिन्हाने निवडणुका लढवत आहे. महाराष्ट्रात ग्रामपंचायत, पंचायत समिती, जिल्हा परिषद, महानगरपालिका, विधानसभा आणि लोकसभा — सर्व स्तरांवर पक्ष उमेदवार उभे करण्याच्या दिशेने कार्यरत आहे.",
    record_title: "आमचा निवडणूक ट्रॅक रेकॉर्ड",
    record: "राष्ट्रीय अध्यक्ष श्री. उदय मंडल यांच्या नेतृत्वाखाली एकूण ७९ उमेदवारांनी निवडणूक लढवून मे २०२६ पर्यंत १,२१,५०४ पक्ष मते मिळवली. मार्च २०२४ ते मे २०२६ या काळात ६५ उमेदवारांनी १,०८,४९१ मते मिळवली.",
    candidate_title: "उमेदवार बणू इच्छिता?",
    candidate_body: "समता पार्टीच्या तिकिटावर निवडणूक लढवण्यास इच्छुक असाल तर पक्षाचे सदस्यत्व घ्या आणि कार्यालयाशी संपर्क साधा.",
    past: [
      { value: "2", label: "राज्य सरकारे" },
      { value: "20", label: "खासदार" },
      { value: "72", label: "आमदार" },
      { value: "1994", label: "राष्ट्रीय पक्ष दर्जा (23/11/1994)" },
    ],
    cms_title: "पक्षाचे मुख्यमंत्री",
    cms: [
      { name: "श्री. नितीश कुमार", detail: "बिहार मुख्यमंत्री — 3 मार्च 2000 ते 10 मार्च 2000" },
      { name: "श्री. राधाबिनोद कोइजम", detail: "मणिपूर मुख्यमंत्री — 15 फेब्रुवारी 2001 ते 1 जून 2001" },
    ],
  },
  hi: {
    intro: "समता पार्टी अपने नाम और 'मशाल' चिह्न से चुनाव लड़ रही है। महाराष्ट्र में ग्राम पंचायत, पंचायत समिति, जिला परिषद, महानगरपालिका, विधानसभा और लोकसभा — सभी स्तरों पर पार्टी उम्मीदवार खड़े करने की दिशा में काम कर रही है।",
    record_title: "हमारा चुनाव ट्रैक रिकॉर्ड",
    record: "राष्ट्रीय अध्यक्ष श्री उदय मंडल के नेतृत्व में कुल 79 उम्मीदवारों ने चुनाव लड़कर मई 2026 तक 1,21,504 पार्टी वोट प्राप्त किए। मार्च 2024 से मई 2026 तक 65 उम्मीदवारों ने 1,08,491 वोट प्राप्त किए।",
    candidate_title: "उम्मीदवार बनना चाहते हैं?",
    candidate_body: "समता पार्टी के टिकट पर चुनाव लड़ने के इच्छुक हैं तो पार्टी की सदस्यता लें और कार्यालय से संपर्क करें।",
    past: [
      { value: "2", label: "राज्य सरकारें" },
      { value: "20", label: "सांसद" },
      { value: "72", label: "विधायक" },
      { value: "1994", label: "राष्ट्रीय पार्टी दर्जा (23/11/1994)" },
    ],
    cms_title: "पार्टी के मुख्यमंत्री",
    cms: [
      { name: "श्री नीतीश कुमार", detail: "बिहार मुख्यमंत्री — 3 मार्च 2000 से 10 मार्च 2000" },
      { name: "श्री राधाबिनोद कोइजम", detail: "मणिपुर मुख्यमंत्री — 15 फरवरी 2001 से 1 जून 2001" },
    ],
  },
  en: {
    intro: "Samata Party contests elections under its own name and the 'Flaming Torch' symbol. In Maharashtra, the party is working towards fielding candidates at every level — Gram Panchayat, Panchayat Samiti, Zilla Parishad, Municipal Corporation, Vidhan Sabha and Lok Sabha.",
    record_title: "Our Election Track Record",
    record: "Under the leadership of National President Shri Uday Mandal, a total of 79 candidates have contested elections and secured 1,21,504 party votes up to May 2026. From March 2024 to May 2026, 65 candidates secured 1,08,491 votes.",
    candidate_title: "Want to Become a Candidate?",
    candidate_body: "If you wish to contest elections on a Samata Party ticket, take party membership and contact the office.",
    past: [
      { value: "2", label: "State Governments" },
      { value: "20", label: "Members of Parliament" },
      { value: "72", label: "MLAs" },
      { value: "1994", label: "National Party Status (23/11/1994)" },
    ],
    cms_title: "Chief Ministers from the Party",
    cms: [
      { name: "Shri Nitish Kumar", detail: "Chief Minister of Bihar — 3 March 2000 to 10 March 2000" },
      { name: "Shri Radhabinod Koijam", detail: "Chief Minister of Manipur — 15 February 2001 to 1 June 2001" },
    ],
  },
};

export default function Elections() {
  const { t, lang } = useLang();
  const [serverBlocks, setServerBlocks] = useState(null);
  useEffect(() => {
    api.get("/pages/elections").then((r) => setServerBlocks(r.data.content?.[lang] || null)).catch(() => {});
  }, [lang]);
  const c = CONTENT[lang];
  const fallback = [
    { title: "", body: c.intro },
    { title: c.record_title, body: c.record },
    { title: "", body: c.past.map((p) => `- ${p.value} — ${p.label}`).join("\n") },
    { title: c.cms_title, body: c.cms.map((cm) => `- ${cm.name}: ${cm.detail}`).join("\n") },
    { title: c.candidate_title, body: c.candidate_body },
  ];
  const blocks = serverBlocks || fallback;

  return (
    <div data-testid="elections-page">
      <section className="bg-emerald-950 text-white py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold" data-testid="elections-heading">{t.elections_title}</h1>
          <p className="text-amber-400 mt-2 italic">"{t.tagline}"</p>
        </div>
      </section>

      <PageSections blocks={blocks} testPrefix="elections" />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 pb-14">
        <div className="bg-emerald-950 text-white rounded-2xl p-8 text-center">
          <Link to="/membership" data-testid="elections-join-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-amber-600 hover:bg-amber-700 font-bold transition-colors">
            {t.join_now}
          </Link>
        </div>
      </section>
    </div>
  );
}
